import moment from "moment";
import { intl } from "LocaleWrapper";
import { Typography } from "@mui/material";
import {
	TimelineItem,
	TimelineSeparator,
	TimelineConnector,
	TimelineContent,
	TimelineOppositeContent,
	TimelineDot,
} from "@mui/lab";
import { DataFormat } from "imports/Utils";
import { FormattedCalendarDate } from "utils/DateUtils";
import { AnglerEvents, getInitialTagSettings, VoyagePlanWaitingEvent } from "../../AnglerUtils";

const AnglerTimelineWaitingEvent = ({ event }: { event: VoyagePlanWaitingEvent }) => {
	const diff = event.endTime && event.startTime ? moment(event.endTime).diff(moment(event.startTime)) : 0;
	const minutes = Math.floor((diff / 1000 / 60));

	return (
		<TimelineItem>
			<TimelineOppositeContent sx={{ m: "auto 0" }}>
				<Typography variant="h6" color="textPrimary" sx={{ fontSize: 12 }}>
					<FormattedCalendarDate date={event.startTime} />
				</Typography>
			</TimelineOppositeContent>

			<TimelineSeparator>
				<TimelineConnector />
				<TimelineDot sx={{ backgroundColor: getInitialTagSettings()[AnglerEvents.Waiting].color }}>
					{getInitialTagSettings()[AnglerEvents.Waiting].icon}
				</TimelineDot>
				<TimelineConnector />
			</TimelineSeparator>

			<TimelineContent sx={{ m: "auto 0" }}>
				<Typography variant="h6" color="textPrimary" sx={{ fontSize: 12 }}>
					{`${intl.formatMessage({ id: "ANGLER_WAITING_TIME" })}: ${DataFormat.minutesToTime(minutes)}`}
				</Typography>
			</TimelineContent>
		</TimelineItem>
	);
};

export default AnglerTimelineWaitingEvent;
